import * as React from "react";
import {DEF} from "../../../const";
import Box from "@mui/material/Box";
import {useEffect} from "react";
import "./WarningInfo.css"


export const WarningInfoState = {
    msg: '',
    show: DEF.POPUP_SHOWING_DEFAULT_TIME,
    timer: null,
}

export const WarningInfo = (
    {
        state,// WarningInfoState
        setState
    }
) => {
    useEffect(() => {
        if(state.timer) {
            clearTimeout(state.timer);
        }
        if (DEF.POPUP_SHOWING_MANUAL_CLOSE !== state.show)
        {
            if (state.msg) {
                const timer = setTimeout(() => {
                    setState(WarningInfoState);
                }, state.show);
                setState(state => ({...state, timer: timer}));
            } else {
                setState(WarningInfoState);
            }
        } else {
            if (!state.msg) {
                setState(WarningInfoState);
            }
        }
    }, [state.msg]);

    return (
        <Box className='warning-info'>
            <Box className='warning-info-frame' role='warning-info-frame'>
                {(DEF.POPUP_SHOWING_MANUAL_CLOSE === state.show) && (
                    <button className='button'
                        onClick={() => setState(state => ({...state, msg: ''}))}
                    >
                        x
                    </button>
                )}

                {state.msg}
            </Box>
        </Box>

    );
};

export default WarningInfo;
